export default {
    methods: {
        manageGroupModal(groupData) {  
            this.$emit('manage-group', groupData);
        }
    }
}